import { IAppContext } from 'shared/common/types/applicationContext';
import { TGenericStore, mapPageTypeToCreateStoreFunction, TGenericStoreState } from '../../../shared/common/redux';

export function createApplicationState(context: IAppContext): TGenericStore {
  const { config } = context;
  const initialState = config.getStrict<TGenericStoreState>('initialState');

  const createStoreFunction = mapPageTypeToCreateStoreFunction[context.custom.pageType];

  return createStoreFunction(context, initialState, true);
}
